import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Divider,
  Image,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Typography,
  message,
} from "antd";
import { ExclamationCircleOutlined, PrinterOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";

import {
  HEADERS_EXPORT_DETAIL,
  POST_CAR_IMPOUND_SUMNOTEFL,
  POST_CAR_IMPOUND_TNOTEFL,
  POST_LOAD_BILL_SALE_IMPOUND,
  POST_SALE_IMPOUND,
} from "../../../API/apiUrls";
import DateCustom from "../../../../hook/DateCustom";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import ExportPDF from "../report/ExportPDF";
const { Text, Title } = Typography;

// ─── Main Modal ───────────────────────────────────────────────────
const ExportDocModal = ({ open, close, record, handleLoad }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const roleId = localStorage.getItem("ROLE_ID");
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const [convertDateThai, convertDateThaiShort] = DateCustom();
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(
    async (signal) => {
      if (!record?.CONTNO) return;
      setLoading(true);
      try {
        const res1 = await axios.post(
          POST_CAR_IMPOUND_TNOTEFL,
          {
            CONTNO: record.CONTNO,
            DATA_TYPE: record.SCHEMA,
            STRNO: record.STRNO,
          },
          { signal },
        );

        const res2 = await axios.post(
          POST_CAR_IMPOUND_SUMNOTEFL,
          {
            DATA_TYPE: record.SCHEMA,
            NOTENO: res1?.data?.TNOTEFL?.[0]?.RUNNO,
          },
          { signal },
        );
        console.log("res2", res2);

        console.log("res1", res1);
      } catch (error) {
        if (axios.isCancel(error) || error.name === "CanceledError") return;
        const errorMsg = error.response?.data?.message || error.message;
        message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      } finally {
        setLoading(false);
      }
    },
    [record],
  );

  useEffect(() => {
    if (!open) return;
    const controller = new AbortController();
    loadData(controller.signal);
    return () => controller.abort();
  }, [open, loadData]);

  const handleClose = () => {
    close(false);
  };

  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: "#faad14" }} />
          <span>ขายรถยึด</span>
        </Space>
      }
      open={open}
      onCancel={handleClose}
      footer={null}
      width={880}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="Loading..."></Spin>
    </Modal>
  );
};

export default ExportDocModal;
